import React from 'react';
import styles from './PasswordRequirements.module.scss';

export interface PasswordRule {
  id: string;
  label: string;
  test: (pw: string) => boolean;
}

export const PASSWORD_RULES: PasswordRule[] = [
  { id: 'length', label: 'At least 8 characters', test: (pw) => pw.length >= 8 },
  { id: 'lower', label: 'A lowercase letter (a–z)', test: (pw) => /[a-z]/.test(pw) },
  { id: 'upper', label: 'An uppercase letter (A–Z)', test: (pw) => /[A-Z]/.test(pw) },
  { id: 'digit', label: 'A number (0–9)', test: (pw) => /\d/.test(pw) },
];

export function isPasswordStrong(pw: string): boolean {
  return PASSWORD_RULES.every((rule) => rule.test(pw));
}

interface Props {
  password: string;
  id?: string;
}

export const PasswordRequirements: React.FC<Props> = ({ password, id }) => {
  return (
    <ul
      id={id}
      className={styles.list}
      aria-label="Password requirements"
    >
      {PASSWORD_RULES.map((rule) => {
        const ok = rule.test(password);
        return (
          <li
            key={rule.id}
            className={ok ? styles.met : styles.unmet}
            aria-live="polite"
          >
            <span className={styles.icon} aria-hidden="true">
              {ok ? '✓' : '○'}
            </span>
            <span className={styles.label}>
              {rule.label}
              <span className={styles.srOnly}>
                {ok ? ' (requirement met)' : ' (requirement not met)'}
              </span>
            </span>
          </li>
        );
      })}
    </ul>
  );
};
